"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelect = makeSelect;

function makeSelect(computedBreakpointRules) {
  return function select(breakpointRule, valueIfMatch, defaultValue) {
    if (computedBreakpointRules[breakpointRule]) {
      return valueIfMatch;
    }

    return defaultValue;
  };
}